module.exports = __webpack_public_path__ + "img/insertLinkWhite.b312798a.svg";